import React, { useState } from "react";

import { isAuthorized } from "@/utils/authToken";

import { getAutomationDataAttr } from "../../../utils/automationUtils";
import { provider_case_manager, provider_peer } from "../../../config/roles";

import AcceptedAgeRangeModal from "./AcceptedAgeRangeModal";
import ProfileDetailsCard from "./ProfileDetailsCard";

const AcceptedAgeRange = (props) => {
  const { acceptedAgeRanges, noBoxShadow, setAcceptedAgeRanges } = props;

  const [showAcceptedAgeRangeModal, setShowAcceptedAgeRangeModal] = useState(false);

  return (
    <>
      {showAcceptedAgeRangeModal && (
        <AcceptedAgeRangeModal
          acceptedAgeRanges={acceptedAgeRanges}
          closeModal={() => setShowAcceptedAgeRangeModal(false)}
          setAcceptedAgeRanges={setAcceptedAgeRanges}
        />
      )}
      <ProfileDetailsCard
        edit={isAuthorized(provider_case_manager) || isAuthorized(provider_peer)}
        heading="Accepted Age Range"
        noBoxShadow={noBoxShadow}
        onclick={() => setShowAcceptedAgeRangeModal(true)}
        testId="AcceptedAgeRange"
      >
        <div
          className="ProviderProfile__states-to-practice my-2 pt-4 px-2 d-flex flex-wrap"
          data-public="true"
        >
          {acceptedAgeRanges.map((acceptedAgeRange, index) => {
            return (
              <AgeRangeDisplay key={index} max={acceptedAgeRange.max} min={acceptedAgeRange.min} />
            );
          })}
        </div>
      </ProfileDetailsCard>
    </>
  );
};

export default AcceptedAgeRange;

const AgeRangeDisplay = (props) => {
  return (
    <div className="d-flex mb-4">
      <div className="d-flex flex-column pr-4">
        <label className="fs-14 tw:font-bold">Lowest Age</label>
        <span {...getAutomationDataAttr("AcceptedAgeRangeMin")}>{props.min}</span>
      </div>
      <div className="d-flex flex-column pr-4">
        <label className="fs-14 tw:font-bold">Highest Age</label>
        <span {...getAutomationDataAttr("AcceptedAgeRangeMax")}>{props.max}</span>
      </div>
      <div className="vertical-break pr-4" />
    </div>
  );
};
